<template>
	<el-dialog title="AI图片生成" :visible.sync="dialogVisible" :close-on-click-modal="false" width="660px" append-to-body>
		<div style="width: 100%;" v-loading="loadLoading" element-loading-text="正在上传图片">
			<div class="chat-list">
				<div class="chat-point">
					<h3>你好，我是AI文思子牙</h3>
					<p>我能够学习和理解人类的语言，进行多轮图片生成哦~</p>
				</div>
				<div v-for="(item, index) in chatList" :key="index">
					<div class="chat-list-main" v-if="item.type === 'chat'">
						<label v-if="item.code !== 200">
							<img style="margin: 0;" v-if="item.loading" class="loading-gif" src="../../assets/images/loading.gif" height="20" />
							<img v-if="item.code === 500" style="margin-top: 2px;" src="../../assets/images/img/i-warning.png" width="20" height="20" />
						</label>

						<div class="box" v-if="!item.value">正在生成，请稍后…</div>
						<div v-else-if="item.code === 200" :toolbar="false">
							<img class="cur" v-viewer :ref="'view-' + index" :src="item.value" width="100%" title="点击预览大图" />
							<div style="display: flex; justify-content: center; padding-top: 5px;">
								<div class="agains-btn" @click="chatList.splice(index, 1)">
									<i class="iconfont icon-Fill1"></i><span>删除图片</span>
								</div>
								<div class="agains-btn" @click="againsFn(chatList[index-1].infos)">
									<i class="iconfont icon-liuliang2"></i><span>重新生成</span>
								</div>
								<div class="agains-btn" @click="viewFn(index)">
									<i class="iconfont icon-zhenduan"></i><span>预览大图</span>
								</div>
								<div class="agains-btn" @click="saveFn(item.value, 'content')">
									<i class="iconfont icon-bangzhuzhongxin"></i><span>选为文章配图</span>
								</div>
                                <div class="agains-btn" @click="saveFn(item.value, 'thumbnail')">
									<i class="iconfont icon-bangzhuzhongxin"></i><span>选为缩略图</span>
								</div>
<!--								<div class="chat-list-main-btn" v-if="!item.loading" @click="saveFn(item.value)">使用图片</div>-->
							</div>
						</div>
						<div class="box" v-else>
							生成失败，请<span class="cur" style="color: #4358AB;" @click="againsFn(chatList[index-1].infos)">重试</span>
						</div>
					</div>
					<div class="user-input" v-if="item.type === 'input'">
						<div>{{ item.value }}</div>
					</div>
				</div>
			</div>
			<div style="display: flex; align-items: flex-start; justify-content: center; margin-top: 24px;">
				<el-input class="refer-content" ref="ReferContent" type="textarea" :rows="2" v-model="referContent" placeholder="你可以输入想要生成图片的指令（enter 快速发送）" @keyup.enter.native="againFn()"></el-input>
				<el-button type="warning" @click="againFn()" round class="cxsc_btn"><img src="./sx2.svg" width="16" height="16">生成图片</el-button>
			</div>
		</div>
	</el-dialog>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import * as qiniu from 'qiniu-js'
export default {
	name: 'galleryTabs',
	components: {

	},
	props: {
		value: {
			type: String
		},
		wSize: {
			type: Number
		},
		hSize: {
			type: Number
		},
	},
	data () {
		return {
			loading: false,
			dialogVisible: false,
			chatList: [],

			referContent: '',
			infos: '',
            loadLoading: false,
		}
	},
	computed: {
		...mapState('template', ['projInfo']),
		imgSrc: {
			get () {
				return this.value
			},
			set (val) {
				this.$emit('input', val)
			}
		},
	},
	methods: {
		initFn(infos) {
			this.dialogVisible = true
			// if (this.chatList.length === 0 && infos !== '<p><br></p>') {
			// 	this.referContent = ''
			// 	this.infos = infos? infos + '。请根据以上文案，生成一张配图。': ''
			// 	this.chatList.push({ value: '请根据文案，生成一张配图。', type: 'input', chatId: '', infos: this.infos })
			// 	if (infos) this.createFn(this.infos, true)
			// 	setTimeout(() => {
			// 		this.$refs.ReferContent.focus()
			// 	}, 500)
			// }
		},
		resettingFn() {
			console.log('重置')
			this.referContent = ''
			this.infos = ''
			this.chatList = []
		},
		createFn(info) {
            if (this.loading) return
			this.loading = true
			const chatId = new Date().getTime() + ('0000' + Math.floor(Math.random() * 100000)).slice(-5)
			const data = {
				content: info,
				// chatId: chatId,
				size: this.findClosestAspectRatio() || '1152x864',
			}
			let wen = ''
			this.referContent = ''
			this.chatList.push({ value: wen, check: false, type: 'chat', chatId, loading: true, code: '', infos: info })
			axios({
				// url: 'https://nsyait.nsw99.com/api/chat/wecom/newsPictures',
				url: 'https://wensi.nswyun.com/api/chat/wecom/newsPictures',
				method: 'POST',
				data,
				// headers: {
				// 	Accept: 'text/event-stream'
				// },
				// responseType: 'stream',
			}).then(res => {
				console.log(res)
				this.loading = false
				this.chatList.forEach(val => {
					if (val.chatId === chatId) {
						val.loading = false
						val.code = res.data.code
						val.value = 'data:image/png;base64,' + res.data.data
					}
				})
				this.scrollFn()
			}, err => {
				console.log(err)
			})
		},
		againFn() {
			if (!this.referContent) return this.$message({ type: 'warning', message: '请输入生成图片的描述' })
			this.infos += this.referContent
			this.chatList.push({ value: this.referContent, type: 'input', chatId: '', infos: this.infos })
			this.scrollFn()
			this.createFn(this.infos)
			// this.createFn(info)
			// this.createFn(info)
		},
		async saveFn(data, type) {
            if (this.loadLoading) return
			this.loadLoading = true
			const file = await this.base64ToFile(data, new Date().getTime() + '.png')
			const url = await this.uploadImg(file)
			if (url) {
				this.$emit('onFileChange', { urlFile: url, thumbnail: type === 'thumbnail' })
				this.dialogVisible = false
			}
			this.loadLoading = false
		},
		againsFn(info) {
			this.scrollFn()
			this.createFn(info)
		},
		// 滚动条自动到底部
		scrollFn() {
			const box = document.getElementsByClassName('chat-list')[0]
			setTimeout(() => {
				this.smoothScroll(box, 1000)
			}, 100)
		},
		smoothScroll(target, duration) {
			const targetPosition = target.scrollHeight
			const startPosition = target.scrollTop
			const distance = targetPosition
			let startTime = null
			function animation(currentTime) {
				if (startTime === null) startTime = currentTime
				const timeElapsed = currentTime - startTime
				const run = ease(timeElapsed, startPosition, distance, duration)
				target.scrollTo(0, run)
				if (timeElapsed < duration) requestAnimationFrame(animation)
			}
			function ease(t, b, c, d) {
				t /= d / 2
				if (t < 1) return (c / 2) * t * t + b
				t--
				return (-c / 2) * (t * (t - 2) - 1) + b
			}
			requestAnimationFrame(animation)
		},
		// 宽高匹配
		findClosestAspectRatio() {
			const sizeList = ['1:1', '4:3', '3:4', '3:2', '2:3', '16:9', '9:16']
			if (this.wSize <= 0 || this.hSize <= 0) {
				return ''
			}

			// banner图兼容，高度距离16:9差太多不给生成
			const height = this.wSize === 1920 && this.hSize < 650 ? 650 : this.hSize

			return this.wSize + 'x' + height

			// 下面是比例匹配
			// const targetRatio = this.wSize / this.hSize
			// let closestRatio = sizeList[0]
			// let smallestDifference = Infinity
			// sizeList.forEach(ratioStr => {
			// 	const [numerator, denominator] = ratioStr.split(':').map(Number)
			// 	const currentRatio = numerator / denominator
			// 	const difference = Math.abs(currentRatio - targetRatio)
			//
			// 	if (difference < smallestDifference) {
			// 		smallestDifference = difference
			// 		closestRatio = ratioStr
			// 	}
			// })
			// return closestRatio
		},
		base64ToFile(dataUrl, filename) {
			if (!dataUrl) return null
			const arr = dataUrl.split(',')
			const mime = arr[0].match(/:(.*?);/)[1]
			const bstr = window.atob(arr[1])
			let n = bstr.length
			const u8arr = new Uint8Array(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new File([u8arr], filename, {
				type: mime
			})
		},
		async getUptoken() {
			return new Promise((resolve, reject) => {
				axios({
					url: '/common/upToken',
					method: 'GET',
				}).then(res => {
					resolve(res)
				})
			})
		},
		async uploadImg(fileData) {
			return new Promise(async (resolve, reject) => {
				let file = fileData
				let { data } = await this.getUptoken()

				let uptoken, qniu_domain
				if (data.isSuccess) {
					uptoken = data.data.uptoken
					qniu_domain = data.data.qniu_domain
				} else {
					this.$message.error('获取token失败')
					return
				}
				let fileName = this.getNewFileName(file), self = this
				let observable = qiniu.upload(file, fileName, uptoken)
				observable.subscribe({
					err() {
						self.$message({
							message: '上传图片失败',
							type: 'err'
						})
						resolve('')
					},
					complete(res) {
						console.log(qniu_domain + res.key)
						resolve(qniu_domain + res.key)
						self.$message({
							message: '上传图片成功',
							type: 'success'
						})
					}
				})
			})
		},
		viewFn(index) {
			this.getUptoken()
			this.$refs['view-' + index][0].click()
		},
		getNewFileName(file) {
			let name = file.name
			let ext = /\.[^\.]+$/.exec(name)[0]
			return `${new Date().getTime()}/aiImages/${this.getRandomString(10)}${ext}`
		},
		getRandomString (num) {
			let arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
			let res = ''
			for (let i = 0; i < num; i++) {
				let id = Math.ceil(Math.random() * 61)
				res += arr[id]
			}
			return res
		},
	}
}
</script>
<style lang="scss" scoped>
	.content_btn {
		height: 0; text-align: right; cursor: pointer; transition: .2s; line-height: 45px; color: #4358AB; opacity: .9;
		&:hover{
			opacity: 1;
		}
		img, span{
			display: inline-block; vertical-align: middle; margin-left: 5px;
		}
	}
	.chat-list{
		min-height: 300px; max-height: 500px; overflow: auto;
		.chat-list-main{
			display: flex; position: relative; padding: 12px; transition: .3s; background: #efefef; border-radius: 0 8px 8px 8px; margin-bottom: 12px;
			label{
				flex: 1; padding-top: 3px; height: 29px;
			}
			div.box{
				flex: 20; line-height: 30px;
			}
			.chat-list-main-btn{
				color: #fff; height: 26px; width: 130px; line-height: 26px; background: #4358AB; border-radius: 3px; padding: 0 10px; font-size: 12px; cursor: pointer; text-align: center; opacity: .95; transition: .3s;
				&:hover{
					opacity: .9;
				}
			}
			.agains-btn{
				display: flex; align-items: center; color: #4358AB; cursor: pointer; line-height: 26px; height: 26px; margin-right: 12px; transition: .3s;
				i, span{
					margin: 0 3px;
				}
				&:hover{
					opacity: .9;
				}
			}
		}
		.user-input{
			display: table;
			max-width: 70%;
			padding: 12px;
			margin: 12px 0 12px auto;
			background: rgba(179, 204, 255, 1);
			border-radius: 8px 0 8px 8px;
		}
	}
</style>
<style lang="scss">
	.cxsc_btn{
		margin-left: 5px; background: #6362E8; border: 0; transition: .2s;
		span{
			display: flex; align-items: center; color: #fff;
			img{
				margin-right: 5px;
			}
		}
		&:hover{
			background: #4945bd;
		}
	}
	.refer-content{
		textarea{
			padding: 10px 15px;
		}
	}
	.viewer-navbar, .viewer-prev, .viewer-play, .viewer-next{
		display: none;
	}
	.viewer-in{
		z-index: 999999;
	}
</style>
